import React, { Component } from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

class SweetAlert extends Component {
   _dismissDialog = () => {
      if (!this.props.cancelDisabled) this.props.onCancel();
   };

   _onCancel = () => {
      if (!this.props.cancelDisabled) this.props.onCancel();
   };

   _onConfirm = () => {
      if (!this.props.confirmDisabled) this.props.onConfirm();
   };

   render() {
      const { show, title, confirmBtnText, cancelBtnText, confirmBtnBsStyle, confirmDisabled, cancelDisabled } = this.props;
      if (!show) {
         return false;
      }

      return (
         <Dialog open={show} onClose={this._dismissDialog} className='SweetAlert'>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>{this.props.children}</DialogContent>
            <DialogActions>
               <Button className={classNames('button', confirmBtnBsStyle)} disabled={confirmDisabled} onClick={this._onConfirm}>
                  {confirmBtnText}
               </Button>
               <Button className={'button'} disabled={cancelDisabled} onClick={this._onCancel}>
                  {cancelBtnText}
               </Button>
            </DialogActions>
         </Dialog>
      );
   }
}

export default SweetAlert;
